module.exports = __webpack_public_path__ + "img/ico-upload-new.d3b79187.svg";